import { MessageCircle, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT, waLink, IMAGES } from "../../lib/site";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="bg-white py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-ink text-white px-8 py-16 md:px-16 md:py-24">
          <img src={IMAGES.ctaTexture} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/40" />
          <div className="relative max-w-2xl">
            <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Parliamone oggi stesso.
            </h2>
            <p className="mt-5 text-lg text-white/70 max-w-xl">
              Ti aiutiamo gratuitamente a trovare l'offerta o il dispositivo più adatto alle tue esigenze.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <a href={waLink()} target="_blank" rel="noreferrer" data-testid="cta-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-brand hover:bg-brand-hover px-8 py-4 font-semibold transition-all duration-200 hover:scale-[1.03] shadow-lg shadow-brand/30">
                <MessageCircle className="w-5 h-5" /> Scrivici su WhatsApp
              </a>
              <a href={`tel:${CONTACT.phonePrimary.tel}`} data-testid="cta-call-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 hover:border-white hover:bg-white/5 px-8 py-4 font-semibold transition-all duration-200">
                <Phone className="w-5 h-5" /> Chiamaci
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
